<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>参数管理</el-breadcrumb-item>
            <el-breadcrumb-item>参数列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!-- {{paramslist}} -->
            <!--参数列表区域-->
            <el-table :data="paramslist" style="width: 100%" stripe size="small" height="430">
                <el-table-column label="ID" type="index"  width="100"></el-table-column>
                <!-- <el-table-column label="经典名琴" prop="param8">
                    <template slot-scope="scope">
                        已设置
                    </template>
                </el-table-column>
                <el-table-column label="在线课程" prop="param9">
                    <template slot-scope="scope">
                        已设置
                    </template>
                </el-table-column> -->
                <el-table-column label="起租" prop="param2">
                    <template slot-scope="scope">
                        已设置
                    </template>
                </el-table-column>
                <el-table-column label="发货" prop="param3">
                    <template slot-scope="scope">
                        已设置
                    </template>
                </el-table-column>
                <el-table-column label="积分" prop="param4">
                    <template slot-scope="scope">
                        已设置
                    </template>
                </el-table-column>
                <el-table-column label="租赁必读" prop="param5">
                    <template slot-scope="scope">
                        已设置
                    </template>
                </el-table-column>
                <el-table-column label="租赁规则" prop="param6">
                    <template slot-scope="scope">
                        已设置
                    </template>
                </el-table-column>
                <el-table-column label="关于VOM" prop="param7">
                    <template slot-scope="scope">
                        已设置
                    </template>
                </el-table-column>
                
                <el-table-column label="操作" fixed="right" width="100">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                        <!-- {{scope.row}} -->
                            <el-button type="primary" icon="el-icon-edit" size="mini" @click="EditParams(scope.row.id)"></el-button>
                            <!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelParams(scope.row.id)"></el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!--参数列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[1, 5, 10, 20]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
        </el-card>
    </div>
</template>
<script>
export default {
    data(){
        return{
            //获取参数列表的参数对象
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 10
            },
            paramslist: [],
            total: 0
        }
    },
    created() {
         this.getParamsList()
    },
    methods:{
        async getParamsList() {
           const { data: res} = await this.$http.get('paramslist/',{ params: this.queryInfo })
           if(res.status == 1){
                this.total = res.data.totalCount;
                this.paramslist = res.data.list.map(v => {
                //在返回的数据里增加一条数据
                // console.log(v.fields)
                return v.fields
                })
            }
            for (let index = 0; index < res.data.list.length; index++) {
                    this.paramslist[index].id= res.data.list[index].pk;
                }
       },
        handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getParamsList()
       },
       handleCurrentChange(newPage){
          // console.log(newPage)
           this.queryInfo.pagenum = newPage
           this.getParamsList()
       },
       async EditParams(id){
        this.$router.push({
                path: `/paramsedit/${id}`
            })
            
       }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
</style>